import { useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import api from "../../lib/api";

export default function AdminPerformance() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/admin/courier-performance").then(({ data }) => setRows(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-performance-page">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-shipany-blue text-white"><Gauge className="h-5 w-5" /></span>
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight text-shipany-navy">Courier Performance</h1>
          <p className="text-sm text-slate-500">Score = delivery 35% + NDR 20% + RTO 15% + pickup 15% + COD 15%.</p>
        </div>
      </div>

      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="courier-performance-table">
        <table className="w-full min-w-[1000px] text-sm">
          <thead>
            <tr className="bg-shipany-navy text-left text-xs uppercase tracking-wider text-white">
              <th className="px-5 py-3.5">Courier</th><th className="px-4 py-3.5">Score</th><th className="px-4 py-3.5">Shipments</th>
              <th className="px-4 py-3.5">Pickup %</th><th className="px-4 py-3.5">Delivery %</th><th className="px-4 py-3.5">NDR %</th>
              <th className="px-4 py-3.5">RTO %</th><th className="px-4 py-3.5">COD %</th><th className="px-4 py-3.5">Avg Days</th>
            </tr>
          </thead>
          <tbody>
            {(rows || []).map((c, i) => (
              <tr key={c.courier_code} className="border-t border-slate-100" data-testid={`perf-row-${c.courier_code}`}>
                <td className="px-5 py-3">
                  <p className="font-semibold text-shipany-navy">#{i + 1} {c.courier_name}</p>
                  <p className="mono text-[10px] capitalize text-slate-400">{c.provider_code}</p>
                </td>
                <td className="px-4 py-3">
                  {c.score === null || c.score === undefined
                    ? <span className="rounded-lg bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-500">Awaiting pickup</span>
                    : <span className={`mono rounded-lg px-2.5 py-1 text-sm font-bold ${c.score >= 80 ? "bg-emerald-50 text-emerald-600" : c.score >= 60 ? "bg-amber-50 text-amber-700" : "bg-red-50 text-red-600"}`}>{c.score}</span>}
                </td>
                <td className="mono px-4 py-3">{c.total}</td>
                <td className="mono px-4 py-3">{c.pickup_success}%</td>
                <td className="mono px-4 py-3 text-emerald-600">{c.delivery_success === null ? "—" : `${c.delivery_success}%`}</td>
                <td className="mono px-4 py-3 text-orange-600">{c.ndr_rate === null ? "—" : `${c.ndr_rate}%`}</td>
                <td className="mono px-4 py-3 text-red-500">{c.rto_rate === null ? "—" : `${c.rto_rate}%`}</td>
                <td className="mono px-4 py-3">{c.cod_success === null ? "—" : `${c.cod_success}%`}</td>
                <td className="mono px-4 py-3">{c.avg_delivery_days ?? "—"}</td>
              </tr>
            ))}
            {rows && rows.length === 0 && <tr><td colSpan={9} className="px-6 py-10 text-center text-slate-400">No courier data yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
